<template lang="pug">
  .invitados
    //notificacion(:show='this.notificadorShow' :tipo='this.notificadorTipo' :mensaje='this.notificadorMensaje' @close='closeNotif()')
    div(v-if="this.invitadoAdd == false")
      button.btn.btn-primary.m-1(v-if = 'edit' @click.prevent='agregarInvitado()') Agregar Invitados
      .card.table-panel(id='')
        .card-header
          h3.card-title
            | Invitados
        .card-body.table-responsive
          table.table.table-bordered.table-condensed.table-striped.table-hover
            thead
              tr
                th.text-center.w-25 RUC
                th.text-center.w-25 Razon Social
                th.text-center.w-25 Correo Electronico
                th.text-center.w-25 Telefono
                th.text-center.w-auto(v-if = 'edit') Acciones
            tbody()

              tr( v-for='(row,index) in listaInvitados')
                td.text-center  {{row.ruc}}
                td.text-center {{row.razon_social}}
                td.text-center {{row.correo_electronico}}
                td.text-center {{row.telefono}}
                td(v-if = 'edit')
                  .btn-group
                    b-dropdown.m-md-1(text='Acciones')
                      b-dropdown-item(@click.prevent='modificarInvitado(row,index)') Modificar
                      b-dropdown-item(@click.prevent='borrarInvitado(row)') Borrar

    b-form(@submit='onSubmit' @reset='onReset' v-if="this.show"  )
      b-card(v-if="this.invitadoAdd == true")
        template(#header='')
          h6.mb-0 Agregar Invitado
        b-card-text
          div
            .form-group.row
              b-form-group#input-group-1.col-sm-1.col-form-label(label='RUC:' label-for='input-ruc')
              .col-sm-7
                b-form-input#input-correo(v-model='invitado.ruc'  @blur.native ='getDatosProveedor(invitado.ruc)')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-2.col-sm-1.col-form-label(label='Razon Social:' label-for='input-razon-social')
              .col-sm-7
                b-form-input#input-ruc(v-model='invitado.razon_social' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Correo:' label-for='input-correo')
              .col-sm-7
                b-form-input#input-correo(v-model='invitado.correo_electronico' type='email' required='')
            .form-group.row
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Telefono:' label-for='input-telefono')
              .col-sm-7
                b-form-input#input-telefono(v-model='invitado.telefono' )

            div.float-right
              button.btn.btn-danger.m-1(type='submit' variant='primary') Grabar
            button.btn.btn-primary.m-1(type='reset' variant='danger') Volver
            //b-button(type='submit' variant='primary') Submit
            //b-button(type='reset' variant='danger') Reset






</template>

<script>


import {HTTP} from "../http";
import functions from "../mixins/functions";

export default {
  name: "Invitados",
  mixins: [functions],
  /*components: {
    Notificacion
  },*/
  props: {
    rfi_id: {
      type: String,
    },
    edit: {
      type: Boolean,
    }
  },
  data() {
    return {
      invitadoAdd: false,
      invitado: {},
      listaInvitados: {},
      datosProveedor: {},
      indexModificado: null,
      show: true,
      requiredFields: [
        'razon_social','correo_electronico'
      ],
    }
  },
  async created(){
    this.listaInvitados = (await HTTP.get('/invitado/listar/',{ params: {solicitudId: this.rfi_id}})).data

  },
  methods: {
    onSubmit(event) {
      this.grabarInvitado(this.invitado)
      event.preventDefault()
    },
    onReset(event) {
      event.preventDefault()
      this.limpiarInvitado();
      // Trick to reset/clear native browser form validation state

    },

    getDatosProveedor:async function(ruc) {

      this.invitado.razon_social = null
      this.invitado.correo_electronico = null
      this.invitado.telefono = null

      this.datosProveedor = (await HTTP.get('/invitado/getProveedor/'+ruc)).data
      this.invitado.razon_social = this.datosProveedor.razon_social
      this.invitado.correo_electronico = this.datosProveedor.email
      this.invitado.telefono = this.datosProveedor.telefono
      this.show = false
      this.$nextTick(()=>{
        this.show = true
      })
    },

    agregarInvitado: function () {
      this.invitadoAdd = true;
    },

    modificarInvitado: async function (row, index) {
      this.invitadoAdd= true;
      this.invitado= row;
      this.indexModificado = index;
    },
    grabarInvitado: async function (instance) {
      instance.rfi_id = decodeURIComponent(this.rfi_id)
      console.log(instance)

      if(!this._checkRequired(instance, this.requiredFields)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar minimamente los campos de Razon Social y Correo'});
      } else {
        try {
          if (this.indexModificado == null) {
            const data = await (HTTP.post('/invitado/create', instance));
            this.listaInvitados = (await HTTP.get('/invitado/listar/' ,{ params: {solicitudId: this.rfi_id}})).data
            window.scrollTo(0, 0);
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Invitado agregado correctamente'});
            this.limpiarInvitado()
            console.log('INVITADO CREADO: ' + data.data);
          } else {
            const data = await (HTTP.post('/invitado/modificar', instance));
            this.listaInvitados = (await HTTP.get('/invitado/listar/',{ params: {solicitudId: this.rfi_id}})).data
            this.limpiarInvitado()
            console.log('INVITADO MODIFICADO: ' + data.data);
          }
        } catch (error) {
          //this.notificar('error', this.title, error.response.data.message)
        }
      }

    },
    limpiarInvitado: function () {
      this.invitadoAdd = false;
      this.invitado= {};
      this.indexModificado = null;
    },

    borrarInvitado: async function (instance) {
      try {
        await HTTP.put(`/invitado/borrar/${instance.id}`, instance);
        this.listaInvitados = (await HTTP.get('/invitado/listar/',{ params: {solicitudId: this.rfi_id}})).data
        this.limpiarInvitado()
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Invitado borrado correctamente'});
      } catch (error) {
        switch (error.response.status) {
            case 404:
              window.scrollTo(0, 0);
              this.$root.$emit('showNotificationSuccess', {mensaje: 'Invitado borrado correctamente'});
              this.listaInvitados = {}
              break;
            case 500:
              console.log('500 error');  // or here
              break;
            default:
              break;
          }
      }
    },




  }
}
</script>

<style scoped>

</style>
